let filtering_list = [];

const changeFilterToAll = () => {
  // 全ての要素を表示
  showAllElem();

  filtering_list.splice(0);
};

const toggleFilter = (filterRoomLayout) => {
  if (filtering_list.includes(filterRoomLayout)) {
    // 選択された要素を非表示
    hiddenSelectedElem(filterRoomLayout);

    const delete_index = filtering_list.findIndex(
      (elem) => elem == filterRoomLayout,
    );
    filtering_list.splice(delete_index, 1);
  } else {
    if (filtering_list.length == 0) {
      // 全ての要素を非表示
      hiddenAllElem();
    }
    // 選択された要素を表示
    showSelectedElem(filterRoomLayout);

    filtering_list.push(filterRoomLayout);
  }
};

const showAllElem = () => {
  const filter_header_content_wrapper = document.getElementById(
    'filter-header-content-wrapper',
  );
  Array.from(filter_header_content_wrapper.children).forEach((a) =>
    a.classList.remove('header-show'),
  );

  const filter_header_all = document.querySelector('.filter-header-ALL');
  filter_header_all.classList.add('header-show');

  const coordinate_wrapper = document.getElementById(
    'coordinate-content-wrapper',
  );
  const coordinate_collection = coordinate_wrapper.children;

  Array.from(coordinate_collection).forEach(
    (a) => (a.style.display = 'initial'),
  );
};

const hiddenAllElem = () => {
  const filter_header_content_wrapper = document.getElementById(
    'filter-header-content-wrapper',
  );
  Array.from(filter_header_content_wrapper.children).forEach((a) =>
    a.classList.remove('header-show'),
  );

  const coordinate_wrapper = document.getElementById(
    'coordinate-content-wrapper',
  );
  const coordinate_collection = coordinate_wrapper.children;

  Array.from(coordinate_collection).forEach((a) => (a.style.display = 'none'));
};

const showSelectedElem = (filterRoomLayout) => {
  const filter_selected_header = document.querySelector(
    '.filter-header-' + filterRoomLayout,
  );
  filter_selected_header.classList.add('header-show');

  document
    .querySelectorAll('.coordinate-item-' + filterRoomLayout)
    .forEach((a) => (a.style.display = 'initial'));
};

const hiddenSelectedElem = (filterRoomLayout) => {
  const filter_selected_header = document.querySelector(
    '.filter-header-' + filterRoomLayout,
  );
  filter_selected_header.classList.remove('header-show');

  document
    .querySelectorAll('.coordinate-item-' + filterRoomLayout)
    .forEach((a) => (a.style.display = 'none'));
};

const sortElemByPV = () => {
  const coordinate_wrapper = document.getElementById(
    'coordinate-content-wrapper',
  );
  let coordinate_collection = coordinate_wrapper.children;
  const btnCreatedAt = document.getElementById('btn-sort-created-at');
  const btnPageView = document.getElementById('btn-sort-page-view');
  btnPageView.classList.add('selected-btn');
  btnCreatedAt.classList.remove('selected-btn');

  coordinate_collection = Array.prototype.slice.call(coordinate_collection);

  coordinate_collection.sort((a, b) => {
    return b.dataset.pageViews - a.dataset.pageViews;
  });

  // reatach the sorted elements
  for (var i = 0, len = coordinate_collection.length; i < len; i++) {
    // store the parent node so we can reatach the item
    var parent = coordinate_collection[i].parentNode;
    // detach it from wherever it is in the DOM
    var detatchedItem = parent.removeChild(coordinate_collection[i]);
    // reatach it.  This works because we are itterating
    // over the items in the same order as they were re-
    // turned from being sorted.
    parent.appendChild(detatchedItem);
  }
};

const sortElemByCreatedAt = () => {
  const coordinate_wrapper = document.getElementById(
    'coordinate-content-wrapper',
  );
  let coordinate_collection = coordinate_wrapper.children;
  const btnCreatedAt = document.getElementById('btn-sort-created-at');
  const btnPageView = document.getElementById('btn-sort-page-view');
  btnCreatedAt.classList.add('selected-btn');
  btnPageView.classList.remove('selected-btn');

  coordinate_collection = Array.prototype.slice.call(coordinate_collection);

  coordinate_collection.sort((a, b) => {
    return a.dataset.createdAt > b.dataset.createdAt ? -1 : 1;
  });

  // reatach the sorted elements
  for (var i = 0, len = coordinate_collection.length; i < len; i++) {
    // store the parent node so we can reatach the item
    var parent = coordinate_collection[i].parentNode;
    // detach it from wherever it is in the DOM
    var detatchedItem = parent.removeChild(coordinate_collection[i]);
    // reatach it.  This works because we are itterating
    // over the items in the same order as they were re-
    // turned from being sorted.
    parent.appendChild(detatchedItem);
  }
};
